import React from 'react'
import { useHistory } from 'react-router-dom'
import ReceiptOutlinedIcon from 'components/material-symbol/icons/Receipt'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import RecordBookingPaymentDialog from '../record-booking-payment-dialog'
import { ActionsWrapper, useStyles } from './styles'

const PaymentActions = ({
  registrationPaymentId,
  enrollment,
  eventTitle,
  eventDate,
  participantName,
  lessonType,
  onPaymentSuccess,
  onOpenPaidOffline,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const allowedToEditSources = ['member', 'room', 'club']
  const { transactions = [] } = enrollment
  const sourceType = transactions[0]?.sourceType
  const isAllowedToEdit = allowedToEditSources.includes(sourceType)
  const handleViewReceiptClick = () => {
    history.push(`/account/payments/transactions/${registrationPaymentId}`)
  }

  const RecordBookingTrigger = (
    <Tooltip title="Modify Payment">
      <IconButton
        className={classes.borderedActionButton}
        aria-label="Modify payment"
      >
        <EditOutlinedIcon fontSize="small" fill={0} />
      </IconButton>
    </Tooltip>
  )

  return (
    <ActionsWrapper>
      <Tooltip title="View Receipt">
        <IconButton
          className={classes.borderedActionButton}
          aria-label="View receipt"
          onClick={handleViewReceiptClick}
        >
          <ReceiptOutlinedIcon fontSize="small" fill={0} />
        </IconButton>
      </Tooltip>
      {isAllowedToEdit &&
        (onOpenPaidOffline ? (
          <Tooltip title="Modify Payment">
            <IconButton
              className={classes.borderedActionButton}
              aria-label="Modify payment"
              onClick={onOpenPaidOffline}
            >
              <EditOutlinedIcon fontSize="small" fill={0} />
            </IconButton>
          </Tooltip>
        ) : (
          <RecordBookingPaymentDialog
            trigger={RecordBookingTrigger}
            enrollment={enrollment}
            eventTitle={eventTitle}
            eventDate={eventDate}
            participantName={participantName}
            defaultAmountInCents={lessonType.priceInCents}
            acceptOnlinePayments={lessonType.acceptsOnlinePayments}
            onPaymentSuccess={onPaymentSuccess}
          />
        ))}
    </ActionsWrapper>
  )
}

export default PaymentActions
